import _ from "lodash";

class ProductActions {
  defaultProduct(products) {
    return _.find(products, product => product.is_default_product) ||
      _.find(products, product => product.product_type === 'MAIN') ||
      _.head(products);
  }

  defaultUpsellProduct(products, defaultCampaignId) {
    return _.find(products, product => product.id === defaultCampaignId) ||
      _.find(products, product => product.is_default_product) ||
      _.find(products, product => product.product_type === 'MAIN') ||
      _.head(products);
  }

  filterInactiveProducts(products) {
    return _.filter(products, product => {
      if (typeof product.is_active !== 'undefined') {
        return product.product_color.active && product.is_active;
      } else {
        return product.product_color.active;
      }
    });
  }

  sizeDisplay(product, size) {
    if (this.isProductClock(product)) {
      if (size === 'M') return '8"';
      else if (size === 'L') return '11"';
      else return size;
    }

    return size;
  }

  isProductClock(product) {
    return product.group ? product.group.toLowerCase() === 'clock' : false;
  }
}

export default new ProductActions();


// WEBPACK FOOTER //
// ./source/client/actions/product.js